import { render, staticRenderFns } from "./AddUserToReportingProfile.vue?vue&type=template&id=2fc5cbb8&"
import script from "./AddUserToReportingProfile.vue?vue&type=script&lang=js&"
export * from "./AddUserToReportingProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports